import { NgIf } from '@angular/common';
import { ChangeDetectionStrategy, Component, ElementRef, Input, ViewChild, AfterViewInit } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { Cart } from '@next/core-lib/cart';
import { AgrI18nSharedModule } from '@next/core-lib/i18n';
import { Store } from '@ngrx/store';

import * as ProductActions from '../../store/actions';

@Component({
  selector: 'app-search-favorites',
  templateUrl: './search-favorites.component.html',
  styleUrls: ['./search-favorites.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgIf, MatButton, MatIcon, AgrI18nSharedModule],
})
export class SearchFavoritesComponent implements AfterViewInit {
  @ViewChild('openFavoritesButton') openFavoritesButton: ElementRef;
  @ViewChild('openFavoritesButtonInTemplate', { static: false }) openFavoritesButtonInTemplate: ElementRef;
  @Input() cart?: Cart;
  @Input() editable;
  @Input() isMainPageButton = false;

  constructor(private readonly store: Store) {}

  ngAfterViewInit() {
    if (this.isMainPageButton) {
      this.openFavoritesButton = this.openFavoritesButtonInTemplate;
    }
  }

  handleClick(): void {
    const htmlButtonRef = this.openFavoritesButton.nativeElement;
    this.store.dispatch(ProductActions.openFavoritesDialog({ cart: this.cart, htmlButtonRef }));
  }
}
